/**
 * Key prefixes for the server-state queries, in one place.
 *
 * They live in `lib/` because `useSearchInFlight` has to recognise both the policy query and the
 * claims query, and a feature may never import another feature. Holding the prefixes here rather
 * than re-typing them at each call site is what turns a rename into a compile error instead of a
 * matcher that silently stops matching and a button that never unblocks.
 */
export const QUERY_KEYS = {
  activeSearch: ['policy', 'active-search'],
  policyDetails: ['policy', 'details'],
  claims: ['claims'],
} as const;
